var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-steps"},[_c('ul',{staticClass:"list-equal"},_vm._l((_vm.steps),function(n){return _c('li',{staticClass:"progress-steps__step",class:{'progress-steps__step--active': _vm.step >= _vm.stagechanges[n-1]}},[_c('span')])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aab007e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressSteps.vue
// module id = Vnys
// module chunks = 1